import React, { FC, useMemo } from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Flex } from '@zazume/zzm-base';

import { AgentTagBody } from '#/models/user/Agent';

const AgentTag = styled.div<{ tagColor: string }>(
  ({ theme, tagColor }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing.s1} ${theme.spacing.s2};
    border-radius: ${theme.radius.base};
    font-family: ${theme.fonts.base};
    font-size: ${theme.fontsSizes.tiny};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights.m};
    background: ${tagColor}1A;
    color: ${tagColor};
    text-transform: capitalize;
  `
);

interface AgentTagsListProps {
  tags: AgentTagBody[] | undefined;
  direction?: 'row' | 'column';
}

export const AgentTagsList: FC<AgentTagsListProps> = ({ tags, direction = 'column' }) => {
  const validTags = useMemo(() => (tags?.length ? [...tags] : []), [tags]);

  if (!validTags.length) {
    return null;
  }

  return (
    <Flex direction={direction} gap="s2" wrap="wrap">
      {validTags.map(tag => (
        <AgentTag key={tag.name} tagColor={tag.color}>
          {tag.name}
        </AgentTag>
      ))}
    </Flex>
  );
};
